/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateAddressDto
 */
export interface UpdateAddressDto {
    /**
     * Address name/label
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'name'?: string;
    /**
     * Contact number for this address
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'contactNumber'?: string;
    /**
     * Address type
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'type'?: UpdateAddressDtoTypeEnum;
    /**
     * Country name
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'country'?: string;
    /**
     * Country code
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'countryCode'?: string;
    /**
     * Province name
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'province'?: string;
    /**
     * Province code
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'provinceCode'?: string;
    /**
     * City name
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'city'?: string;
    /**
     * City code
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'cityCode'?: string;
    /**
     * Barangay name
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'barangay'?: string;
    /**
     * Barangay code
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'barangayCode'?: string;
    /**
     * Street address
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'street'?: string;
    /**
     * Additional address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'addressLine2'?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'postalCode'?: string;
    /**
     * Source API for address data
     * @type {string}
     * @memberof UpdateAddressDto
     */
    'sourceApi'?: UpdateAddressDtoSourceApiEnum;
}

export const UpdateAddressDtoTypeEnum = {
    Home: 'home',
    Work: 'work',
    Shipping: 'shipping'
} as const;

export type UpdateAddressDtoTypeEnum = typeof UpdateAddressDtoTypeEnum[keyof typeof UpdateAddressDtoTypeEnum];
export const UpdateAddressDtoSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type UpdateAddressDtoSourceApiEnum = typeof UpdateAddressDtoSourceApiEnum[keyof typeof UpdateAddressDtoSourceApiEnum];


